import * as types from "../types/dashboard.types";
import moment from "moment";

const dateFormat = 'YYYY-MM-DD hh:mm:ss a';
const d = moment().format("YYYY-MM-DD")


const initialState = {
  riderCurrentOrder: [],
  riderCurrentOrderPagi: [],
  riderCurrentOrderStore: [],
  metricsDashboardData: [],
  // metricsDashboardFilter: null,
  metricsDashboardFilter: {
    storeId: null,
    date: [moment(), moment()],
  },
  metricsDashboardLoader: false,

  shiftDashboardData: [],
  shiftMartDashboardData: [],
  shiftDashboardPaginationData: [],
  shiftDashboardLoader: false,
  martDashboardFilter: {
    zoneIds: [],
    start_date: moment(d + ' ' + '08:00:00', dateFormat ),
    end_date: moment(d + ' ' + '03:00:00', dateFormat).add(1, 'days'),
  },
  shiftDashboardFilter: {
    zoneIds: [],
    start_date: moment(d + ' ' + '08:00:00', dateFormat ),
    end_date: moment(d + ' ' + '03:00:00', dateFormat).add(1, 'days'),
  },
};

const DashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_RIDER_CURRENT_ORDER_DATA:
      return { ...state, riderCurrentOrder: action.payload };
    case types.SET_RIDER_CURRENT_ORDER_DATA_PAGINATION_DATA:
      return { ...state, riderCurrentOrderPagi: action.payload };
    case types.SET_RIDER_CURRENT_ORDER_STOREID_DATA:
      return { ...state, riderCurrentOrderStore: action.payload };
    case types.SET_METRICS_DASHBOARD_DATA:
      return { ...state, metricsDashboardData: action.payload };
    case types.SET_METRICS_DASHBOARD_FILTER:
      return { ...state, metricsDashboardFilter: action.payload };
    case types.SET_METRICS_DASHBOARD_LOADER:
      return { ...state, metricsDashboardLoader: action.payload };

    case types.SET_SHIFTS_LIST:
      return { ...state, shiftDashboardData: action.payload };
    case types.SET_SHIFTS_MART_LIST:
        return { ...state, shiftMartDashboardData: action.payload };
    case types.SET_PAGINATION_SHIFTS_LIST:
      return { ...state, shiftDashboardPaginationData: action.payload };
    case types.SET_SHIFTS_LOADING:
      return { ...state, shiftDashboardLoader: action.payload };
    case types.SET_MART_FILTER:
      return { ...state, martDashboardFilter: action.payload };
    case types.SET_SHIFTS_FILTER:
      return { ...state, shiftDashboardFilter: action.payload };

    case types.RESET_DASHBOARD_REDUCER:
      return { 
        ...state, 
        riderCurrentOrder: [],
        riderCurrentOrderPagi: [],
        riderCurrentOrderStore: [],
        MetricsDashboardData: [],
        MetricsDashboardFilter: {},
        shiftDashboardData: [],
        shiftDashboardPaginationData: [],
        shiftDashboardLoader: false,
        martDashboardFilter: initialState.martDashboardFilter,
        shiftDashboardFilter: initialState.shiftDashboardFilter,
      };
    default:
      return state;
  }
};
export default DashboardReducer;
